import { type ReactElement, type ReactNode } from 'react';
import { CLONE_TABLE_PANEL_HEADER_HEIGHT } from '@/features/shared/components/tableSystem/tableConstants';
import { Panel } from '@/ui/composites/Panel';
import { Stack } from '@/ui/layout/Stack';
import { Box, Tab, Tabs } from '@/ui/primitives';

type DetailTablePanelProps = {
  tabLabel: string;
  tabsAriaLabel: string;
  toolbarSlot?: ReactNode;
  actionsSlot?: ReactNode;
  children: ReactNode;
};

export const DetailTablePanel = ({
  tabLabel,
  tabsAriaLabel,
  toolbarSlot,
  actionsSlot,
  children,
}: DetailTablePanelProps): ReactElement => (
  <Panel
    padding="xl"
    gap="none"
    contentGap="md"
    headerGap="none"
    headerSlot={
      <Box
        sx={{
          width: '100%',
          minWidth: 0,
          borderBottom: 1,
          borderColor: 'divider',
          minHeight: `${CLONE_TABLE_PANEL_HEADER_HEIGHT}px`,
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          gap="md"
          sx={{
            minWidth: 0,
            minHeight: `${CLONE_TABLE_PANEL_HEADER_HEIGHT}px`,
            height: `${CLONE_TABLE_PANEL_HEADER_HEIGHT}px`,
          }}
        >
          <Box sx={{ minWidth: 0, flex: '1 1 auto' }}>
            <Tabs value={tabLabel} aria-label={tabsAriaLabel}>
              <Tab
                label={tabLabel}
                value={tabLabel}
                disableRipple
                sx={{
                  cursor: 'default',
                  pointerEvents: 'none',
                }}
              />
            </Tabs>
          </Box>
          {toolbarSlot || actionsSlot ? (
            <Stack direction="row" alignItems="center" gap="md" sx={{ flex: '0 0 auto' }}>
              {actionsSlot}
              {toolbarSlot}
            </Stack>
          ) : null}
        </Stack>
      </Box>
    }
    sx={{ backgroundColor: 'background.paper', width: '100%', minWidth: 0 }}
  >
    <Box sx={{ width: '100%', minWidth: 0 }}>{children}</Box>
  </Panel>
);
